import type { TextAlign } from '../types';

export const wrapText = (text: string, width: number, fontSize: number): string[] => {
  const paragraphs = text.replace(/\r/g, '').split('\n');
  const lines: string[] = [];
  const maxChars = Math.max(3, Math.floor(width / Math.max(1, fontSize * 0.56)));

  paragraphs.forEach((paragraph, paragraphIndex) => {
    const words = paragraph.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) {
      lines.push('');
      return;
    }
    let current = '';
    words.forEach((word) => {
      if (word.length > maxChars) {
        if (current) {
          lines.push(current);
          current = '';
        }
        for (let i = 0; i < word.length; i += maxChars) {
          lines.push(word.slice(i, i + maxChars));
        }
        return;
      }
      const candidate = current ? `${current} ${word}` : word;
      if (candidate.length > maxChars && current) {
        lines.push(current);
        current = word;
      } else {
        current = candidate;
      }
    });
    if (current) lines.push(current);
    if (paragraphIndex < paragraphs.length - 1) lines.push('');
  });
  return lines.length ? lines : [''];
};

export const textAnchorFor = (align: TextAlign): 'start' | 'middle' | 'end' => {
  if (align === 'left') return 'start';
  if (align === 'right') return 'end';
  return 'middle';
};

export const textXFor = (align: TextAlign, x: number, width: number, padding: number): number => {
  if (align === 'left') return x + padding;
  if (align === 'right') return x + width - padding;
  return x + width / 2;
};
